import React, {Component} from 'react';

import {Link} from 'react-router-dom';

import {Container, Col, Row} from 'react-bootstrap';

class PageFooter extends Component {

    render = () => {
        return (
            <>
            <div className="hk-footer" style={{backgroundColor: '#F4F4F4'}}>
                <Container as="footer" className="footer">
                    <Row>
                        <Col xl={12}>
                            <p className="footer-text">
                                <span className="copy-text">EEC มีงานทำ HRD</span>
                                <span className="copy-text">| Powered by Grow Up Tech Co., Ltd.  © 2025</span>
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>            
            </>
        )
    }
}
export default PageFooter;